const { validator, validComparableTypes } = require('./utils/validation');

module.exports = {
  test({ params, rule }) {

    if (!params.hasOwnProperty(rule.variableName)) {
      return false;
    }

    const paramsValue = params[rule.variableName];

    return paramsValue === rule.value;
  },

  validate: validator({
    'Rule must have a `variableName` property': rule => 'variableName' in rule,
    "Rule's `variableName` property must be a string": rule => typeof rule.variableName === 'string',
    'Rule must have a `value` property': rule => 'value' in rule,
    'Rule value must be a string, number, or boolean': rule => validComparableTypes.has(typeof rule.value), 
  })
};
